import { Sun, Users, Workflow, Building2, BarChart3 } from "lucide-react";

export const SECTIONS = [
  { key: "today", label: "Today", icon: Sun, to: "/crm", match: ["/crm/tasks"],
    subs: [["Action queue", "/crm"], ["Tasks", "/crm/tasks"]] },
  { key: "customers", label: "Customers", icon: Users, to: "/crm/contacts",
    match: ["/crm/contacts", "/crm/contact/", "/crm/duplicates", "/crm/leads", "/crm/vendor-leads", "/crm/investors", "/crm/archive"],
    subs: [["All customers", "/crm/contacts"], ["Website enquiries", "/crm/leads"], ["Vendors", "/crm/vendor-leads"], ["Investors", "/crm/investors"], ["Duplicates", "/crm/duplicates"], ["Archive", "/crm/archive"]] },
  { key: "pipeline", label: "Pipeline", icon: Workflow, to: "/crm/pipeline",
    match: ["/crm/pipeline", "/crm/referral-dashboard", "/crm/referrals", "/crm/stage-review"],
    subs: [["Vendor pipeline", "/crm/pipeline"], ["Auction referrals", "/crm/referral-dashboard"], ["All referrals", "/crm/referrals"], ["Stage review", "/crm/stage-review"]] },
  { key: "properties", label: "Properties", icon: Building2, to: "/crm/properties",
    match: ["/crm/properties", "/crm/resources"],
    subs: [["Properties & deals", "/crm/properties"], ["Resources", "/crm/resources"]] },
  { key: "reports", label: "Reports", icon: BarChart3, to: "/crm/reports",
    match: ["/crm/reports", "/crm/conversions", "/crm/overview", "/crm/settings"],
    subs: [["Reports", "/crm/reports"], ["Conversions", "/crm/conversions"], ["Investor overview", "/crm/overview"], ["Settings", "/crm/settings"]] },
];

export const activeSection = (path) =>
  path === "/crm" || path === "/crm/" ? SECTIONS[0]
    : SECTIONS.find((s) => s.match.some((m) => path.startsWith(m))) || SECTIONS[0];
